import { motion } from 'framer-motion';
import styled from 'styled-components';

export const InfiniteSliderWrapper = styled.div`
  display: inline-flex;

  width: 100%;
`;

export const InfiniteSliderInner = styled(motion.div)`
  display: inline-flex;
`;

export const ContentLine = styled.div`
  display: inline-flex;
`;

export const EmptySpace = styled.div`
  width: 100%;
`;

export const ContentWrapper = styled.div``;
